import { drinkstypes } from "./drinkstypes";

export const mangoIncrease = () => {
    return {
        type : drinkstypes.MANGO_INCREASE,
        payload : 50
    }
}
export const mangoDecrease = () => {
    return {
        type : drinkstypes.MANGO_DECREASE,
        payload : 50
    }
}
export const coldCoffeeIncrease = () => {
    return {
        type : drinkstypes.COLD_COFFEE_INCREASE,
        payload : 25
    }
}
export const coldCoffeeDecrease = () => {
    return {
        type : drinkstypes.COLD_COFFEE_DECREASE,
        payload : 25
    }
}
export const coffeeIncrease = () => {
    return {
        type : drinkstypes.COFFEE_INCREASE,
        payload : 20
    }
}
export const coffeeDecrease = () => {
    return {
        type : drinkstypes.COFFEE_DECREASE,
        payload : 20
    }
}
export const pepsiIncrease = () => {
    return {
        type : drinkstypes.PEPSI_INCREASE,
        payload : 60
    }
}
export const pepsiDecrease = () => {
    return {
        type : drinkstypes.PEPSI_DECREASE,
        payload : 60
    }
}
export const clearAllDrinks = () => {
    return { type : drinkstypes.CLEAR_ALL_DRINKS }
}